
const dataConfiguracion = window.ConfigExternalApp;

const GnlCarpetaServicios = dataConfiguracion.ConfigModule.Rutas.CarpetaServicios; //process.env.REACT_APP_FOLDER_SERVICES;
export const GnlCarpetaModulos = dataConfiguracion.ConfigModule.Rutas.CarpetaModulos; //process.env.REACT_APP_FOLDER_MODULES;
export const GnlNombreCarpetaModulo = dataConfiguracion.ConfigModule.Rutas.NombreCarpetaModulo; // process.env.REACT_APP_FOLDER_NAME_MODULE;

export const GnlNombreModulo = dataConfiguracion.ConfigModule.Configuracion.NombreModulo; //process.env.REACT_APP_NAME_MODULE;

const GnlUrlBaseServiciosApp = dataConfiguracion.ConfigModule.Rutas.UrlBaseServicios + GnlCarpetaServicios; //process.env.REACT_APP_URL_SERVICES + GnlCarpetaServicios;
export const GnlUrlBaseServicios = dataConfiguracion.ConfigModule.Rutas.UrlBaseServicios;
export const GnlUrlBaseModulosApp = dataConfiguracion.ConfigModule.Rutas.UrlBaseModulos + GnlCarpetaModulos; //process.env.REACT_APP_URL_MODULES + GnlCarpetaModulos;

export const GnlUrlBaseSitioWeb = dataConfiguracion.ConfigModule.Rutas.UrlBaseModulos;

export const GnlReferenciaModulo = "Modulo" + dataConfiguracion.ConfigModule.Configuracion.ReferenciaModulo; //process.env.REACT_APP_MODULE_REFERENCE;

export const GnlCarpetaModuloReporte = dataConfiguracion.ConfigModule.Configuracion.ReferenciaModulo;

export const GnlNotificacionesSistema = dataConfiguracion.ConfigModule.Configuracion.NotificacionesSistema;

export const GnlIdiomaDefecto = dataConfiguracion.ConfigModule.Configuracion?.IdiomaDefecto;

export const GnlUrlClassStore = dataConfiguracion.ConfigModule.Configuracion?.UrlClassStore;

export const GnlUrlVisorReportes = dataConfiguracion.ConfigModule.Reportes?.UrlVisorExterno;

export const GnlUrlCarpetaReportesMigrador = dataConfiguracion.ConfigModule.Reportes?.CarpetaMigrador;

export const LlavesInformesConfig = { /*src/Configuracion/Informes/InformesConfig.js*/
    SSSRConfig: {
        EndPointUrl: dataConfiguracion.ConfigModule.Reportes.UrlEndPointReportes,//process.env.REACT_APP_SSSR_ENDPOINT, /*Punto de acceso al WCF expuesto por RS para accer a los informes  */
        UserName: dataConfiguracion.ConfigModule.Reportes.UsuarioReportes, //process.env.REACT_APP_SSSR_USER_NAME, /*Usuario que se configura para el acceso a SSRS*/
        Password: dataConfiguracion.ConfigModule.Reportes.ClaveReportes, //process.env.REACT_APP_SSSR_USER_PASS, /*Contraseña del usuario que se configura para el acceso a SSRS*/
        Domain: dataConfiguracion.ConfigModule.Reportes.DominioReportes, //process.env.REACT_APP_SSSR_USER_DOMAIN, /*dominio del usuario que se configura para el acceso a SSRS*/
        RootFolder: dataConfiguracion.ConfigModule.Reportes.FolderBase, //process.env.REACT_APP_SSSR_ROOT_FOLDER, /*carpeta raiz de reportes*/
        ModuleFolder: dataConfiguracion.ConfigModule.Reportes.FolderModulo, //process.env.REACT_APP_SSSR_MODULE_FOLDER /*carpeta de reportes para el módulo*/
    },
    RutaDescarga: dataConfiguracion.ConfigModule.Reportes.PathDescarga, //process.env.REACT_APP_PATH_DOWNLOAD, /*Ruta Fisica publicada en el IIS donde el visor busca el archivo que se renderiza para mostrarlo*/
    RutaGuardadoArchivo: dataConfiguracion.ConfigModule.Reportes.PathGuardar, //process.env.REACT_APP_PATH_SAVE_FILE /*Ruta Fisica donde el Api que brinda el servicio al visor deja el archivo fisico del renderizado*/
}

export const LlavesAuthConfig = { /*src/Configuracion/AuthConfig.js*/
    auth: {
        clientId: dataConfiguracion.ConfigModule.AuthLogin.ClienteIdAut, //process.env.REACT_APP_AUTH_CONFIG_CLIENT_ID,
        authority: dataConfiguracion.ConfigModule.AuthLogin.UrlAutorizacion, //process.env.REACT_APP_AUTH_CONFIG_AUTHORITY,
        redirectUri: GnlUrlBaseModulosApp + "/Login/auth/login"
    },
    cache: {
        cacheLocation: dataConfiguracion.ConfigModule.AuthLogin.UbicacionCache, //process.env.REACT_APP_AUTH_CONFIG_CACHE_LOCATION, // This configures where your cache will be stored
        storeAuthStateInCookie: dataConfiguracion.ConfigModule.AuthLogin.StateInCookie, //process.env.REACT_APP_AUTH_CONFIG_STATE_INCOOKIE, // Set this to "true" if you are having issues on IE11 or Edge
    },
    loginRequest: {
        scopes: [dataConfiguracion.ConfigModule.AuthLogin.Scopes], //[process.env.REACT_APP_AUTH_CONFIG_SCOPES],
        redirectUri: GnlUrlBaseModulosApp + "/Login/auth/login"
    },
    graphConfig: {
        graphMeEndpoint: dataConfiguracion.ConfigModule.AuthLogin.GraphMeEndPoint, //process.env.REACT_APP_AUTH_CONFIG_GRAPHME_ENDPOINT
    },
    view: {
        loginType: dataConfiguracion.ConfigModule.AuthLogin.LoginType //redirect o popup
    }
}

export const LlavesConfiguraciones = { /*src/Configuracion/Configuraciones.js*/
    rutaPublicacion: GnlCarpetaModulos + "/" + GnlNombreCarpetaModulo,        /* Server donde se publica la aplicacion para desarrollo seria vacia y en el IIS la ruta que contiene al app Ejms (/MODULOS/App) */
    tiempoSesion: dataConfiguracion.ConfigModule.Configuracion.TiempoSesionUsuario, //process.env.REACT_APP_SESION_TIME,          /*Se usa para indicar el tiempo en milisegundos que se tiene para mantener la sesion al completarse debe de salir de la sesion y regresar a login  */
    moduloActual: "Sistema de Gestión Acadedmica - Universidad",        /*Codigo del modulo actual (usado para operaciones de seguridad)*/
    urlModuloLogin: GnlUrlBaseModulosApp + "/Login/auth/login",  /*En caso de vencer el tiempo de sesion o para otras operaciones representa la url del sitio de login */
    urlModuloLoginHome: GnlUrlBaseModulosApp + "/Login/home/home",
    rutaPublicacionCompleta: GnlUrlBaseModulosApp + "/" + GnlNombreCarpetaModulo, /*URL completa a la carpeta raiz del modulo*/
}

export const LlavesEndPointServicios = { /*src/Servicios/*.js*/
    UrlServicioCore: GnlUrlBaseServiciosApp + "/Core/api",
    UrlServicioLogin: GnlUrlBaseServiciosApp + "/Login/api",
    UrlServicioClass: GnlUrlBaseServiciosApp + "/Class/api",
    UrlServicioParametros: GnlUrlBaseServiciosApp + "/Parametros/api",
    UrlServicioSeguridad: GnlUrlBaseServiciosApp + "/Seguridad/api",
    UrlServicioReportesFisico: GnlUrlBaseServiciosApp + "/VisorReporte/api",
    UrlServicioReportesObjeto: GnlUrlBaseServiciosApp + "/VisorReporte/api"
}

export const LlavesEndPointModulos = {
    UrlBaseModulos: GnlUrlBaseModulosApp
}

export const LlavesApiEnvioCorreos = {
    UrlEndPointEnvioCorreos: dataConfiguracion.ConfigModule.ServicioCorreo.UrlServicio //process.env.REACT_APP_SEND_EMAIL_ENDPOINT
}

export const LLavesModuloUtilidades = {
    rutaNotificaciones: GnlUrlBaseModulosApp + "/" + dataConfiguracion.ConfigModule?.ModuloUtilidades?.NombreModulo + dataConfiguracion.ConfigModule?.ModuloUtilidades?.PathNotificaciones,
    rutaAgenda: GnlUrlBaseModulosApp + "/" + dataConfiguracion.ConfigModule?.ModuloUtilidades?.NombreModulo + dataConfiguracion.ConfigModule?.ModuloUtilidades?.PathAgenda,
    rutaControlVersiones: GnlUrlBaseModulosApp + "/" + dataConfiguracion.ConfigModule?.ModuloUtilidades?.NombreModulo + dataConfiguracion.ConfigModule?.ModuloUtilidades?.PathControlVersiones
}